import { Input } from 'antd';
import styled, { css } from 'styled-components';
import { Color } from '../../config/Color';
import { appOverride } from '../../util/AppUtils';
import { bodyFontStyle } from './Typography';

export const textInputStyles = css`
  border-radius: ${appOverride({ nerva: '14px', default: '0' })};
  ${bodyFontStyle};
  &,
  &:focus,
  &:hover {
    border-top: ${appOverride({ nerva: '2px solid', default: 'none' })};
    border-left: ${appOverride({ nerva: '2px solid', default: 'none' })};
    border-right: ${appOverride({ nerva: '2px solid', default: 'none' })};
    border-bottom: ${appOverride({ nerva: '2px solid', default: '1px solid' })};
    border-color: ${appOverride({
      nerva: 'rgba(245, 245, 245, 0.25)',
      default: Color.content.default,
    })};
    box-shadow: none;
    text-align: center;
    font-size: ${({ theme }) => theme.fontSize.md};
    background: transparent;
    color: ${appOverride({ nerva: Color.content.default, default: 'inherit' })};
    padding: ${appOverride({ nerva: '12px 16px', default: '4px 11px' })};
  }
  &:focus,
  &:focus-within {
    border-color: ${appOverride({ nerva: Color.content.default, default: Color.flow.accent })};
  }
  &::placeholder {
    color: ${appOverride({ nerva: '#f5f5f5', default: Color.content.default })};
    opacity: 0.25;
  }
`;

export const TextInput = styled(Input)`
  ${textInputStyles}
`;
